"use client";

import Image from "next/image";

type LoginHeroProps = {
  rotatingMessage: string;
};

export function LoginHero({ rotatingMessage }: LoginHeroProps) {
  return (
    <section className={"flex w-full min-h-0 flex-col items-center justify-center px-[clamp(1rem,2.2vh,1.2rem)] py-[clamp(0.75rem,1.7vh,1rem)] text-center lg:items-start lg:px-[clamp(1.15rem,2vw,1.8rem)] lg:py-[clamp(0.9rem,2.1vh,1.3rem)] lg:text-left 2xl:px-[clamp(1.7rem,2vw,2.4rem)] 2xl:py-[clamp(1.2rem,2.3vh,1.85rem)]"}>
      <a
        href="https://eamir.org"
        target="_blank"
        rel="noreferrer"
        className="mb-[clamp(0.55rem,1.1vh,0.8rem)] flex justify-center transition hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-ring)] lg:justify-start"
        aria-label="Open EAMIR.org"
        title="EAMIR.org"
      >
        <Image
          src="/branding/eamir-icon.png"
          alt="EAMIR"
          className="h-[clamp(4.1rem,8vw,6.6rem)] w-auto object-contain"
          sizes="(min-width: 1536px) 106px, (min-width: 1024px) 92px, 72px"
          width={512}
          height={512}
          priority
        />
      </a>
      <p className={"type-eyebrow"}>
        Built by EAMIR
      </p>
      <h1 className={"type-display-title mt-[0.45rem] max-w-[34rem] text-[clamp(1.9rem,1.45rem+1.9vw,3.65rem)]"}>
        IMAGS
      </h1>
      <p className={"type-eyebrow mt-[0.35rem]"}>
        Music-Induced Analgesia Genome Study
      </p>

      <p className={"type-eyebrow mt-[0.35rem]"}>
        Research Platform
      </p>

      <p className={"type-display-lead mt-2.5 max-w-[31rem] text-[clamp(0.92rem,0.89rem+0.18vw,1.08rem)]"}>
        Capture synchronized music playback with GSR telemetry,
        then store clean session data for downstream clinical research
        analysis.
      </p>

      <p
        className={
          "theme-button-secondary type-pill-label mt-3 inline-flex max-w-full items-center justify-center rounded-full border px-3 py-2 lg:justify-start"
        }
      >
        {rotatingMessage}
      </p>
    </section>
  );
}
